 /* eslint-disable */
function VideoController(triggers, modalContain, modalClose, videoIds, accountId, playerId) {
    this.modalOpen = false;
    this.activeVideo = '';
    this.modalContain = modalContain;
    this.modalClose = modalClose;
    this.accountId = accountId || '5974301536001';
    this.playerId = playerId || 'default';
    this.videoIds = videoIds;
    this.isIE = !!navigator.userAgent.match(/Trident/g) || !!navigator.userAgent.match(/MSIE/g)

    this.modalClose.addEventListener('click', this.closeModal.bind(this));

    triggers.forEach(trigger => {
        trigger.addEventListener('click', this.handleTriggerClick.bind(this));
    });

    
    this.videoIds.forEach((id, i) => {
        if(document.querySelector(`video[data-video-id="${ id }"]`) === null) {
                //load videos differenly for IE, since it complains about media source error problems
                //we use iframe code directly from Brightcove.
                if(this.isIE) {
                    const ieIframe = this.createIframeForIE(id);
                    modalContain.appendChild(ieIframe);
                }
                else {
                    const iframe = this.createIframe(id);
                    modalContain.appendChild(iframe);
                    var self = this;
                    setTimeout(function() {
                        self.populateIframe(iframe, id);
                    }, 1000)
                }
        }
    });
}

VideoController.prototype.populateIframe = function(iframe, id) {
    const doc = iframe.contentDocument;
    const body = doc.body;
    const html = doc.documentElement;
    const contain = document.createElement('div');
    const video = document.createElement('video');
    const script = document.createElement('script');

    iframe.contentWindow.addEventListener('message', this.receiveMessage);

    script.src = `//players.brightcove.net/${this.accountId}/${this.playerId}_default/index.min.js`;

    contain.setAttribute('class', 'video-modal-contain');
    contain.setAttribute('data-video-id', id);

    video.setAttribute('data-video-id', id);
    video.setAttribute('data-account', this.accountId);
    video.setAttribute('data-player', this.playerId);
    video.setAttribute('data-embed', 'default');
    video.setAttribute('data-application-id', '');
    video.setAttribute('class', 'video-js');
    video.setAttribute('controls', true);
    video.setAttribute('style', 'position: absolute; top: 0px; right: 0px; bottom: 0px; left: 0px; width: 100%; height: 100%;'); 

    
    contain.appendChild(video);
    contain.appendChild(script);
    body.appendChild(contain);

};

VideoController.prototype.createIframe = function(id) {
    const iframe = document.createElement('iframe');
    iframe.setAttribute('src', 'about:blank');
    iframe.setAttribute('width', '100%');
    iframe.setAttribute('height', '0');
    iframe.setAttribute('frameBorder', '0');
    iframe.setAttribute('scrolling', 'no');
    iframe.setAttribute('sandbox', 'allow-forms allow-popups allow-pointer-lock allow-same-origin allow-scripts');
    iframe.setAttribute('style', 'min-width: 320px !important; max-width: 960px !important; max-height: 540px !important');
    iframe.setAttribute('class', 'video-modal-contain');
    iframe.setAttribute('data-video-id', id);
    iframe.setAttribute('allowfullscreen', true);

    return iframe;
};

VideoController.prototype.receiveMessage = function(message) {
    //console.log("message: " + message);
    switch(message.data) {
        case 'play': 
            try {
                this.document.querySelector('video').play()
                .catch(e => {
                    //console.log(e)
                }); 
            } catch(e) {
                //console.log(e)
            }
            break;
        case 'pause':
            try {
                this.document.querySelector('video').pause(); 
            } catch(e) {
                //console.log(e);
            }
            break;
        default:
            break;
    }
};



VideoController.prototype.openModal = function() {
    // clear active videos
    this.modalOpen = true;
    /* document.querySelectorAll('.video-modal-contain').forEach(contain => {
        contain.classList.remove('video-modal-contain--active')
    }); */
    var contain = document.querySelectorAll('.video-modal-contain'); 
    for (var i = 0, len = contain.length; i < len; i++) {
        contain[i].classList.remove('video-modal-contain--active')

    }
    document.querySelector(`.video-modal-contain[data-video-id="${this.activeVideo}"]`).classList.add('video-modal-contain--active');
    this.play(this.activeVideo);
    this.modalContain.classList.add('video-modal--open');
};

VideoController.prototype.closeModal = function() {
    //console.log("close modal window");
    this.modalOpen = false;
    this.modalContain.classList.remove('video-modal--open');
    this.pause(this.activeVideo);
    this.videoIds.forEach(id => {
        try {
            this.pause(id);
        } catch(e) {
            //console.log(e);
        }
    });
    if(this.isIE) {
        if(this.activeVideo) {
            var activeVideoID = '#video-'+this.activeVideo;
                //console.log(activeVideoID);
                var elem = document.querySelector(`${activeVideoID}`);
                if( typeof elem === 'undefined' || elem === null ){
                    // Do stuff
                    //console.log("null or undefined");
                }
            else {
                elem.src = `//players.brightcove.net/${this.accountId}/${this.playerId}_default/index.html?videoId=${this.activeVideo}`;
            }
        }
        
        
    }
};

VideoController.prototype.play = function(id) {
    if(id) {
        const videoContainer = document.querySelector(`.video-modal-contain[data-video-id="${id}"]`);
        videoContainer.contentWindow.postMessage('play', '*');
        
    }
};

VideoController.prototype.pause = function(id) {
    if(id) {
        const videoContainer = document.querySelector(`.video-modal-contain[data-video-id="${id}"]`);
        videoContainer.contentWindow.postMessage('pause', '*');
    }
}

VideoController.prototype.handleTriggerClick = function(e) {
    this.activeVideo = e.currentTarget.getAttribute('data-video-id');
    if(this.isIE) {
        this.openIEModal();
    }
    else {
        this.openModal();
    }
    
};
VideoController.prototype.createIframeForIE = function(id) {

    const iframe = document.createElement('iframe');
    iframe.setAttribute('src', `//players.brightcove.net/${this.accountId}/${this.playerId}_default/index.html?videoId=${id}`);
    iframe.setAttribute('width', '100%');
    iframe.setAttribute('height', '0');
    iframe.setAttribute('frameBorder', '0');
    iframe.setAttribute('scrolling', 'no');
    iframe.setAttribute('sandbox', 'allow-forms allow-popups allow-pointer-lock allow-same-origin allow-scripts');
    iframe.setAttribute('style', 'position: absolute; top: 0px; right: 0px; bottom: 0px; left: 0px; width: 960px; height: 540px; min-width: 320px; margin: auto;');
    iframe.setAttribute('class', 'video-modal-contain');
    iframe.setAttribute('data-video-id', id);
    iframe.setAttribute('id', 'video-'+id);
    iframe.setAttribute('allowfullscreen', true);

    return iframe;

}

VideoController.prototype.loadSrcIE = function(id, selector) {
    
    const getIframe = document.querySelector(`${selector}`);    

    var searchForAutoplay = getIframe.src.indexOf("autoplay");
    //console.log(searchForAutoplay);
    if(searchForAutoplay == -1) {
        getIframe.src = `//players.brightcove.net/${this.accountId}/${this.playerId}_default/index.html?videoId=${id}&autoplay=true`;
    }
    
}

VideoController.prototype.openIEModal = function() {
    // clear active videos
    this.modalOpen = true;

    var contain = document.querySelectorAll('.video-modal-contain'); 
    for (var i = 0, len = contain.length; i < len; i++) {
        contain[i].classList.remove('video-modal-contain--active')

    }
    document.querySelector(`.video-modal-contain[data-video-id="${this.activeVideo}"]`).classList.add('video-modal-contain--active');
    this.loadSrcIE(this.activeVideo, "#video-"+this.activeVideo);
    this.play(this.activeVideo);
    this.modalContain.classList.add('video-modal--open');
}

export default VideoController
